import { render } from "./MainNav2.vue?vue&type=template&id=406abfb0&scoped=true"
import script from "./MainNav2.vue?vue&type=script&lang=js"
export * from "./MainNav2.vue?vue&type=script&lang=js"

import "./MainNav2.vue?vue&type=style&index=0&id=406abfb0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406abfb0"]])

export default __exports__